// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: "Inter", sans-serif;
    background-color: #181A20;
    overflow-x: hidden;
    max-width: 100%;
    position: relative;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    text-rendering: geometricPrecision;
    font-weight: 400;
}

@supports (overflow: clip) {
    body {
        overflow-x: clip;
        overflow-y: auto;
    }
}

body {
    background-color: #000;
}

html {
    scroll-behavior: auto !important;
    overflow-x: hidden;
    max-width: 100%;
    overscroll-behavior-x: none;
}

@supports (overflow: clip) {
    html {
        overflow-x: clip;
        overflow-y: auto;
    }
}

#root {
    overflow-x: hidden;
    max-width: 100%;
}

@supports (overflow: clip) {
    #root {
        overflow-x: clip;
        overflow-y: visible;
    }
}

#root:has(header.sticky-top) {
    padding-top: 58px;
}

html:has(header.sticky-top) {
    scroll-padding-top: 58px;
}

h1 {
    font-family: "Inter", sans-serif;
    font-size: 3.2rem;
}

h2 {
    font-family: "Inter", sans-serif;
}

.h2,
h2 {
    font-size: 3.2rem;
}

a {
    text-decoration: none;
    transition: 0.5s all;
}

img {
    max-width: 100%;
}

ul {
    list-style: none;
    padding: 0px;
    margin: 0px;
}

p {
    font-size: 18px;
    line-height: 140%;
    font-weight: 300;
}


/* ========== CONTAINER OVERRIDE (style.css) ========== */

.container,
.container-lg,
.container-md,
.container-sm,
.container-xl,
.container-xxl {
    max-width: 1380px;
    padding: 0px 20px;
}


/* ========== HERO (style.css) ========== */

.meme_hero_s {
    background-color: #181A20;
    padding: 60px 0px 20px;
    position: relative;
    color: #fff;
    /* background-image: url(../images/banner_bg_l.png);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat; */
}

.meme_hero_s .container {
    width: 80%;
}

.meme_coin_top {
    display: flex;
    justify-content: space-between;
    gap: 32px;
    align-items: baseline;
}

.meme_coin_top h1 {
    font-size: 60px;
    font-weight: 700;
}

.meme_coin_top p {
    font-size: 22px;
    font-weight: 400;
}

.meme_coin_cnt {
    width: 100%;
}

.meme_right_img {
    width: 50%;
    position: relative;
}

.banner_images {
    width: 350px;
}

.banner_hotCoinContainer {
    display: flex;
    justify-content: center;
    gap: 10px;
}

.banner_bottom_img {
    position: absolute;
    bottom: 0;
    width: 70%;
    left: 0;
    right: 0;
    margin: 0 auto;
}

.banner_coinMask_animation {
    position: absolute;
    bottom: 0;
}

.rounded_img {
    border: 10px solid #cae0f7;
    border-radius: 100%;
    overflow: hidden;
    width: 160px;
}

.left_img {
    position: relative;
    left: 25px;
    top: 10px;
}

.right_img {
    position: relative;
    right: 25px;
    top: 10px;
}

.center_img {
    position: relative;
    z-index: 666;
}


/* ========== LISTING SECTION (style.css) ========== */

.meme_listing_section {
    padding: 40px 0px 0px;
    background-color: #181A20;
    color: #fff;
    display: inline-block;
    width: 100%;
}

.meme_listing_section .container {
    width: 80%;
}

.meme_listing_section .crypto_icon {
    text-align: center;
}

.meme_listing_section .tab-content>.tab-pane {
    padding-right: 0px;
    height: 100%;
}

.meme_listing_section .top_heading {
    align-items: center;
    justify-content: space-between;
    gap: 24px;
}

.meme_listing_section .top_heading h4 {
    margin-bottom: 0px;
}

.top_heading {
    display: flex;
    margin-bottom: 6px;
    justify-content: center;
    align-items: center;
}


/* ========== SEARCH (style.css) ========== */

.search_items {
    background-color: #3c3c3c;
    padding: 10px;
    border-radius: 50px;
}

.search_items input[type="text"] {
    background-color: transparent;
    color: #fff;
    border: none;
    font-size: 13px;
    font-weight: 300;
    margin-left: 12px;
}

.search_items input[type="text"]:focus {
    border: none !important;
}

.search_items img {
    width: 18px;
    opacity: 0.7;
}


/* ========== DASHBOARD TABS (style.css) ========== */

.dashboard_summary ul.nav-tabs li button {
    border: none !important;
    padding: 0px;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    box-shadow: none !important;
    background-color: none;
}

.dashboard_summary ul.nav-tabs {
    border: none;
    display: flex;
    margin-top: 20px;
    gap: 24px;
}

.dashboard_summary ul.nav-tabs li button.active {
    background-color: transparent;
    color: #c59351;
}

.dashboard_summary .green {
    color: #5EBA89;
    font-weight: 600;
}

.dashboard_summary .red {
    color: #E45561;
}

body .red {
    color: #e04457;
}


/* ========== CRYPTO LIST / CARDS (style.css) ========== */

.crypto_list {
    margin: 24px 0px;
}

.crypto_list ul {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
}

.crypto_list ul li {
    background-color: #373E4B;
    padding: 16px;
    border-radius: 15px;
    border: 1px solid #373E4B;
}

.crypto_list ul li .crypto_icon img {
    border-radius: 16px;
}

.coin-card_cardItemWrapper {
    margin: 20px 0px 0px;
}

.coin-card_itemcnt {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    font-size: 15px;
    color: #e0e0e0;
}

.coin-card_itemcnt h6 {
    font-size: 13px;
    font-weight: 300;
}

.cursor {
    cursor: pointer;
}


/* ========== WHAT ARE MEME COINS (style.css) ========== */

.what_coin_s {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin: 60px 0px 30px;
}

.what_coin_s h2 {
    font-size: 32px;
}

.what_coin_s p {
    font-size: 14px;
    margin: 0px;
    color: #cdcdcd;
}


/* ========== LIGHT THEME (light_theme.css) ========== */

body.light_theme {
    background-color: #fff !important;
}

body.light_theme .meme_hero_s {
    background-color: #ffffff;
    color: #383838;
}

body.light_theme .meme_listing_section {
    background-color: #f4f4f4;
    color: #2c2c2c;
}

body.light_theme .crypto_list ul li {
    background-color: #eaeaea;
    border: 1px solid #d3d3d3;
}

body.light_theme .coin-card_itemcnt {
    color: #505050;
}

body.light_theme .what_coin_s p {
    color: #5d5d5d;
}

body.light_theme .search_items {
    background-color: #eaeaea;
}

body.light_theme .search_items input[type="text"] {
    color: #505050;
}

body.light_theme .search_items input[type="text"]::placeholder {
    color: #84888C;
}

body.light_theme .search_items input[type="text"]:focus {
    color: #505050;
}

body.light_theme .search_items input[type="text"]:focus::placeholder {
    color: #84888C;
}


/* ========== RESPONSIVE (style.css) ========== */

@media screen and (max-width:1700px) {

    .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl,
    .container-xxl {
        max-width: 90%;
    }
}

@media screen and (max-width:1440px) {
    h1 {
        font-size: 2.8rem;
    }

    #root:has(header.sticky-top) {
        padding-top: 40px;
    }

    html:has(header.sticky-top) {
        scroll-padding-top: 40px;
    }
}

@media screen and (max-width:1367px) {
    h1 {
        font-size: 2.5rem;
    }

    h1 {
        font-size: 2.2rem;
    }

    .meme_hero_s {
        padding: 0px 0px 20px;
    }
}

@media screen and (max-width:1200px) {

    .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl,
    .container-xxl {
        max-width: 95%;
    }

    .meme_hero_s .container {
        width: 90%;
    }

    .crypto_list ul {
        grid-template-columns: repeat(3, 1fr);
    }

    .meme_listing_section .container {
        width: 90%;
    }

    .meme_coin_top h1 {
        font-size: 36px;
    }

    .meme_coin_top p {
        font-size: 15px;
    }

    .top_heading h4 {
        font-size: 18px;
    }

    p {
        font-size: 16px;
    }
}

@media screen and (max-width:991px) {
    .what_coin_s p {
        font-size: 13px;
    }

    .coin-card_itemcnt {
        font-size: 13px;
    }

    .coin-card_itemcnt h6 {
        font-size: 13px;
    }

    .crypto_list ul {
        grid-template-columns: repeat(2, 1fr);
    }

    p {
        font-size: 14px;
    }
}

@media screen and (max-width:767px) {
    #root:has(header.sticky-top) {
        padding-top: 40px;
    }

    html:has(header.sticky-top) {
        padding-top: 0px;
    }

    h1 {
        font-size: 1.7rem;
    }

    p {
        font-size: 14px;
    }

    .crypto_list ul li .crypto_icon img {
        height: auto;
    }

    .search_items {
        padding: 5px 10px;
    }

    .search_items {
        display: flex;
    }

    .banner_images {
        width: 320px;
    }

    .banner_images.banner_hotCoin {
        width: 250px;
    }

    span.green {
        font-size: 13px !important;
    }

    .what_coin_s p {
        font-size: 14px;
    }

    .crypto_list {
        margin: 0px 0px;
    }

    .meme_coin_top h1 {
        font-size: 28px;
    }

    .meme_coin_top p {
        font-size: 14px;
    }

    .what_coin_s h2 {
        font-size: 20px;
        margin: 0px;
    }

    .what_coin_s {
        gap: 15px;
        margin: 30px 0px 10px;
    }

    .top_heading {
        margin-bottom: 0px;
    }

    .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl,
    .container-xxl {
        max-width: 98%;
    }
}

@media screen and (max-width:660px) {
    .banner_images.banner_hotCoin {
        margin: 0 auto;
    }

    .meme_right_img {
        width: 100%;
    }

    .banner_images {
        width: 290px;
    }

    .meme_coin_cnt {
        text-align: center;
        padding-top: 22px;
    }

    .what_coin_s {
        text-align: center;
    }

    .meme_coin_top h1 {
        font-size: 24px;
    }

    .meme_coin_top p {
        font-size: 13px;
    }

    .meme_coin_top {
        gap: 12px;
        flex-direction: column;
    }

    .meme_listing_section {
        padding: 20px 0px 0px;
    }

    .crypto_list ul {
        grid-template-columns: repeat(1, 1fr);
    }

    .coin-card_itemcnt {
        font-size: 12px;
    }

    .coin-card_itemcnt h6 {
        font-size: 12px;
    }
}

@media screen and (max-width:480px) {
    p {
        font-size: 12px;
    }
}

@media screen and (max-width:414px) {
    .what_coin_s p {
        font-size: 12px;
    }

    .search_items {
        width: 150px;
    }

    .search_items input[type="text"] {
        width: 100%;
        font-size: 12px;
        margin-left: 6px;
    }

    .top_heading h4 {
        margin: 0px;
    }

    .top_heading {
        align-items: start;
    }

    p {
        font-size: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/MemePage/Meme.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;;IAElB,mCAAmC;IACnC,kCAAkC;IAClC,kCAAkC;IAClC,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI;QACI,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA,yDAAyD;;AAEzD;;;;;;IAMI,iBAAiB;IACjB,iBAAiB;AACrB;;;AAGA,2CAA2C;;AAE3C;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX;;;mCAG+B;AACnC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,OAAO;IACP,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;;AAGA,sDAAsD;;AAEtD;IACI,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;IACX,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA,6CAA6C;;AAE7C;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA,qDAAqD;;AAErD;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;AAGA,0DAA0D;;AAE1D;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;;AAGA,0DAA0D;;AAE1D;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;AAClB;;;AAGA,wDAAwD;;AAExD;IACI,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;AAGA,iDAAiD;;AAEjD;;IAEI;;;;;;QAMI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA;;IAEI;;;;;;QAMI,cAAc;IAClB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,SAAS;QACT,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;;;;;QAMI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["body {\n    font-family: \"Inter\", sans-serif;\n    background-color: #181A20;\n    overflow-x: hidden;\n    max-width: 100%;\n    position: relative;\n\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    text-rendering: optimizeLegibility;\n    text-rendering: geometricPrecision;\n    font-weight: 400;\n}\n\n@supports (overflow: clip) {\n    body {\n        overflow-x: clip;\n        overflow-y: auto;\n    }\n}\n\nbody {\n    background-color: #000;\n}\n\nhtml {\n    scroll-behavior: auto !important;\n    overflow-x: hidden;\n    max-width: 100%;\n    overscroll-behavior-x: none;\n}\n\n@supports (overflow: clip) {\n    html {\n        overflow-x: clip;\n        overflow-y: auto;\n    }\n}\n\n#root {\n    overflow-x: hidden;\n    max-width: 100%;\n}\n\n@supports (overflow: clip) {\n    #root {\n        overflow-x: clip;\n        overflow-y: visible;\n    }\n}\n\n#root:has(header.sticky-top) {\n    padding-top: 58px;\n}\n\nhtml:has(header.sticky-top) {\n    scroll-padding-top: 58px;\n}\n\nh1 {\n    font-family: \"Inter\", sans-serif;\n    font-size: 3.2rem;\n}\n\nh2 {\n    font-family: \"Inter\", sans-serif;\n}\n\n.h2,\nh2 {\n    font-size: 3.2rem;\n}\n\na {\n    text-decoration: none;\n    transition: 0.5s all;\n}\n\nimg {\n    max-width: 100%;\n}\n\nul {\n    list-style: none;\n    padding: 0px;\n    margin: 0px;\n}\n\np {\n    font-size: 18px;\n    line-height: 140%;\n    font-weight: 300;\n}\n\n\n/* ========== CONTAINER OVERRIDE (style.css) ========== */\n\n.container,\n.container-lg,\n.container-md,\n.container-sm,\n.container-xl,\n.container-xxl {\n    max-width: 1380px;\n    padding: 0px 20px;\n}\n\n\n/* ========== HERO (style.css) ========== */\n\n.meme_hero_s {\n    background-color: #181A20;\n    padding: 60px 0px 20px;\n    position: relative;\n    color: #fff;\n    /* background-image: url(../images/banner_bg_l.png);\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat; */\n}\n\n.meme_hero_s .container {\n    width: 80%;\n}\n\n.meme_coin_top {\n    display: flex;\n    justify-content: space-between;\n    gap: 32px;\n    align-items: baseline;\n}\n\n.meme_coin_top h1 {\n    font-size: 60px;\n    font-weight: 700;\n}\n\n.meme_coin_top p {\n    font-size: 22px;\n    font-weight: 400;\n}\n\n.meme_coin_cnt {\n    width: 100%;\n}\n\n.meme_right_img {\n    width: 50%;\n    position: relative;\n}\n\n.banner_images {\n    width: 350px;\n}\n\n.banner_hotCoinContainer {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n}\n\n.banner_bottom_img {\n    position: absolute;\n    bottom: 0;\n    width: 70%;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n}\n\n.banner_coinMask_animation {\n    position: absolute;\n    bottom: 0;\n}\n\n.rounded_img {\n    border: 10px solid #cae0f7;\n    border-radius: 100%;\n    overflow: hidden;\n    width: 160px;\n}\n\n.left_img {\n    position: relative;\n    left: 25px;\n    top: 10px;\n}\n\n.right_img {\n    position: relative;\n    right: 25px;\n    top: 10px;\n}\n\n.center_img {\n    position: relative;\n    z-index: 666;\n}\n\n\n/* ========== LISTING SECTION (style.css) ========== */\n\n.meme_listing_section {\n    padding: 40px 0px 0px;\n    background-color: #181A20;\n    color: #fff;\n    display: inline-block;\n    width: 100%;\n}\n\n.meme_listing_section .container {\n    width: 80%;\n}\n\n.meme_listing_section .crypto_icon {\n    text-align: center;\n}\n\n.meme_listing_section .tab-content>.tab-pane {\n    padding-right: 0px;\n    height: 100%;\n}\n\n.meme_listing_section .top_heading {\n    align-items: center;\n    justify-content: space-between;\n    gap: 24px;\n}\n\n.meme_listing_section .top_heading h4 {\n    margin-bottom: 0px;\n}\n\n.top_heading {\n    display: flex;\n    margin-bottom: 6px;\n    justify-content: center;\n    align-items: center;\n}\n\n\n/* ========== SEARCH (style.css) ========== */\n\n.search_items {\n    background-color: #3c3c3c;\n    padding: 10px;\n    border-radius: 50px;\n}\n\n.search_items input[type=\"text\"] {\n    background-color: transparent;\n    color: #fff;\n    border: none;\n    font-size: 13px;\n    font-weight: 300;\n    margin-left: 12px;\n}\n\n.search_items input[type=\"text\"]:focus {\n    border: none !important;\n}\n\n.search_items img {\n    width: 18px;\n    opacity: 0.7;\n}\n\n\n/* ========== DASHBOARD TABS (style.css) ========== */\n\n.dashboard_summary ul.nav-tabs li button {\n    border: none !important;\n    padding: 0px;\n    font-size: 12px;\n    font-weight: 700;\n    color: #fff;\n    box-shadow: none !important;\n    background-color: none;\n}\n\n.dashboard_summary ul.nav-tabs {\n    border: none;\n    display: flex;\n    margin-top: 20px;\n    gap: 24px;\n}\n\n.dashboard_summary ul.nav-tabs li button.active {\n    background-color: transparent;\n    color: #c59351;\n}\n\n.dashboard_summary .green {\n    color: #5EBA89;\n    font-weight: 600;\n}\n\n.dashboard_summary .red {\n    color: #E45561;\n}\n\nbody .red {\n    color: #e04457;\n}\n\n\n/* ========== CRYPTO LIST / CARDS (style.css) ========== */\n\n.crypto_list {\n    margin: 24px 0px;\n}\n\n.crypto_list ul {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 24px;\n}\n\n.crypto_list ul li {\n    background-color: #373E4B;\n    padding: 16px;\n    border-radius: 15px;\n    border: 1px solid #373E4B;\n}\n\n.crypto_list ul li .crypto_icon img {\n    border-radius: 16px;\n}\n\n.coin-card_cardItemWrapper {\n    margin: 20px 0px 0px;\n}\n\n.coin-card_itemcnt {\n    display: flex;\n    justify-content: space-between;\n    gap: 20px;\n    font-size: 15px;\n    color: #e0e0e0;\n}\n\n.coin-card_itemcnt h6 {\n    font-size: 13px;\n    font-weight: 300;\n}\n\n.cursor {\n    cursor: pointer;\n}\n\n\n/* ========== WHAT ARE MEME COINS (style.css) ========== */\n\n.what_coin_s {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    margin: 60px 0px 30px;\n}\n\n.what_coin_s h2 {\n    font-size: 32px;\n}\n\n.what_coin_s p {\n    font-size: 14px;\n    margin: 0px;\n    color: #cdcdcd;\n}\n\n\n/* ========== LIGHT THEME (light_theme.css) ========== */\n\nbody.light_theme {\n    background-color: #fff !important;\n}\n\nbody.light_theme .meme_hero_s {\n    background-color: #ffffff;\n    color: #383838;\n}\n\nbody.light_theme .meme_listing_section {\n    background-color: #f4f4f4;\n    color: #2c2c2c;\n}\n\nbody.light_theme .crypto_list ul li {\n    background-color: #eaeaea;\n    border: 1px solid #d3d3d3;\n}\n\nbody.light_theme .coin-card_itemcnt {\n    color: #505050;\n}\n\nbody.light_theme .what_coin_s p {\n    color: #5d5d5d;\n}\n\nbody.light_theme .search_items {\n    background-color: #eaeaea;\n}\n\nbody.light_theme .search_items input[type=\"text\"] {\n    color: #505050;\n}\n\nbody.light_theme .search_items input[type=\"text\"]::placeholder {\n    color: #84888C;\n}\n\nbody.light_theme .search_items input[type=\"text\"]:focus {\n    color: #505050;\n}\n\nbody.light_theme .search_items input[type=\"text\"]:focus::placeholder {\n    color: #84888C;\n}\n\n\n/* ========== RESPONSIVE (style.css) ========== */\n\n@media screen and (max-width:1700px) {\n\n    .container,\n    .container-lg,\n    .container-md,\n    .container-sm,\n    .container-xl,\n    .container-xxl {\n        max-width: 90%;\n    }\n}\n\n@media screen and (max-width:1440px) {\n    h1 {\n        font-size: 2.8rem;\n    }\n\n    #root:has(header.sticky-top) {\n        padding-top: 40px;\n    }\n\n    html:has(header.sticky-top) {\n        scroll-padding-top: 40px;\n    }\n}\n\n@media screen and (max-width:1367px) {\n    h1 {\n        font-size: 2.5rem;\n    }\n\n    h1 {\n        font-size: 2.2rem;\n    }\n\n    .meme_hero_s {\n        padding: 0px 0px 20px;\n    }\n}\n\n@media screen and (max-width:1200px) {\n\n    .container,\n    .container-lg,\n    .container-md,\n    .container-sm,\n    .container-xl,\n    .container-xxl {\n        max-width: 95%;\n    }\n\n    .meme_hero_s .container {\n        width: 90%;\n    }\n\n    .crypto_list ul {\n        grid-template-columns: repeat(3, 1fr);\n    }\n\n    .meme_listing_section .container {\n        width: 90%;\n    }\n\n    .meme_coin_top h1 {\n        font-size: 36px;\n    }\n\n    .meme_coin_top p {\n        font-size: 15px;\n    }\n\n    .top_heading h4 {\n        font-size: 18px;\n    }\n\n    p {\n        font-size: 16px;\n    }\n}\n\n@media screen and (max-width:991px) {\n    .what_coin_s p {\n        font-size: 13px;\n    }\n\n    .coin-card_itemcnt {\n        font-size: 13px;\n    }\n\n    .coin-card_itemcnt h6 {\n        font-size: 13px;\n    }\n\n    .crypto_list ul {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    p {\n        font-size: 14px;\n    }\n}\n\n@media screen and (max-width:767px) {\n    #root:has(header.sticky-top) {\n        padding-top: 40px;\n    }\n\n    html:has(header.sticky-top) {\n        padding-top: 0px;\n    }\n\n    h1 {\n        font-size: 1.7rem;\n    }\n\n    p {\n        font-size: 14px;\n    }\n\n    .crypto_list ul li .crypto_icon img {\n        height: auto;\n    }\n\n    .search_items {\n        padding: 5px 10px;\n    }\n\n    .search_items {\n        display: flex;\n    }\n\n    .banner_images {\n        width: 320px;\n    }\n\n    .banner_images.banner_hotCoin {\n        width: 250px;\n    }\n\n    span.green {\n        font-size: 13px !important;\n    }\n\n    .what_coin_s p {\n        font-size: 14px;\n    }\n\n    .crypto_list {\n        margin: 0px 0px;\n    }\n\n    .meme_coin_top h1 {\n        font-size: 28px;\n    }\n\n    .meme_coin_top p {\n        font-size: 14px;\n    }\n\n    .what_coin_s h2 {\n        font-size: 20px;\n        margin: 0px;\n    }\n\n    .what_coin_s {\n        gap: 15px;\n        margin: 30px 0px 10px;\n    }\n\n    .top_heading {\n        margin-bottom: 0px;\n    }\n\n    .container,\n    .container-lg,\n    .container-md,\n    .container-sm,\n    .container-xl,\n    .container-xxl {\n        max-width: 98%;\n    }\n}\n\n@media screen and (max-width:660px) {\n    .banner_images.banner_hotCoin {\n        margin: 0 auto;\n    }\n\n    .meme_right_img {\n        width: 100%;\n    }\n\n    .banner_images {\n        width: 290px;\n    }\n\n    .meme_coin_cnt {\n        text-align: center;\n        padding-top: 22px;\n    }\n\n    .what_coin_s {\n        text-align: center;\n    }\n\n    .meme_coin_top h1 {\n        font-size: 24px;\n    }\n\n    .meme_coin_top p {\n        font-size: 13px;\n    }\n\n    .meme_coin_top {\n        gap: 12px;\n        flex-direction: column;\n    }\n\n    .meme_listing_section {\n        padding: 20px 0px 0px;\n    }\n\n    .crypto_list ul {\n        grid-template-columns: repeat(1, 1fr);\n    }\n\n    .coin-card_itemcnt {\n        font-size: 12px;\n    }\n\n    .coin-card_itemcnt h6 {\n        font-size: 12px;\n    }\n}\n\n@media screen and (max-width:480px) {\n    p {\n        font-size: 12px;\n    }\n}\n\n@media screen and (max-width:414px) {\n    .what_coin_s p {\n        font-size: 12px;\n    }\n\n    .search_items {\n        width: 150px;\n    }\n\n    .search_items input[type=\"text\"] {\n        width: 100%;\n        font-size: 12px;\n        margin-left: 6px;\n    }\n\n    .top_heading h4 {\n        margin: 0px;\n    }\n\n    .top_heading {\n        align-items: start;\n    }\n\n    p {\n        font-size: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
